import { SVGProps } from "react";

const ShareIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 20" fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.5 14.136c-.76 0-1.44.302-1.96.774l-7.13-4.167a3.3 3.3 0 0 0 .09-.703 3.3 3.3 0 0 0-.09-.703l7.05-4.126a2.98 2.98 0 0 0 2.04.813c1.66 0 3-1.345 3-3.012A3.002 3.002 0 0 0 15.5 0c-1.66 0-3 1.345-3 3.012 0 .241.04.472.09.703L5.54 7.84a2.98 2.98 0 0 0-2.04-.813c-1.66 0-3 1.345-3 3.012a3.002 3.002 0 0 0 3 3.012c.79 0 1.5-.311 2.04-.813l7.12 4.177c-.05.21-.08.431-.08.652A2.93 2.93 0 0 0 15.5 20a2.93 2.93 0 0 0 2.92-2.932 2.93 2.93 0 0 0-2.92-2.932Z"
            clipRule="evenodd"
        />
    </svg>
);
export default ShareIcon;
